import packageJSON from '../../package.json';

export const APP_VERSION = packageJSON.version;

export const categoryHealthStats = [
    'average monthly searches',
    'average brand searches',
    'predicted growth',
];
export const brandHealthStats = [
    'average monthly searches',
    'price point',
    'predicted growth',
];
export const categoryHealthStatsNonTikTok = categoryHealthStats.filter(
    (metric) => metric !== 'predicted growth',
);
export const brandHealthStatsNonTikTok = brandHealthStats.filter(
    (metric) => metric !== 'predicted growth',
);

const GEO = {
    GLOBAL: 'GLOBAL',
    US: 'US',
    GB: 'GB',
    FR: 'FR',
    KR: 'KR',
    JP: 'JP',
};

export const COUNTRIES_ORDER = [
    GEO.US,
    GEO.GB,
    GEO.FR,
    GEO.KR,
    GEO.JP,
    GEO.GLOBAL,
];

export const CAT1 = {
    BEAUTY: 'beauty',
    PERSONAL_CARE: 'personal care',
    WELLNESS: 'wellness',
    INGREDIENTS: 'ingredients',
    HOME_AND_PET: 'home & pet',
    CULTURAL_SHIFTS: 'cultural shifts',
    GROCERY: 'grocery',
    BEVERAGES: 'beverages',
    CULINARY: 'culinary',
    OCCASIONS: 'occasions',
    AUDIENCE: 'audience',
    BODY_PARTS: 'body parts',
    DOGS: 'dogs',
    MANIPULATION: 'manipulation',
    FLAVORS: 'flavors',
    PRODUCT_SPECIFICS: 'product specifics',
};

export const DATA_SOURCES = {
    GOOGLE: 'GOOGLE',
    TIKTOK: 'TIKTOK',
    INSTAGRAM: 'INSTAGRAM',
    POPULARITY: 'POPULARITY',
};

export const FOOD_ROOTS = [CAT1.GROCERY, CAT1.BEVERAGES, CAT1.CULINARY];

export const ROOT_NAMES = [
    CAT1.BEAUTY,
    CAT1.PERSONAL_CARE,
    CAT1.WELLNESS,
    CAT1.INGREDIENTS,
    CAT1.HOME_AND_PET,
    CAT1.CULTURAL_SHIFTS,
    ...FOOD_ROOTS,
    CAT1.OCCASIONS,
    CAT1.AUDIENCE,
];

export const INDUSTRIES = [
    CAT1.BEAUTY,
    CAT1.PERSONAL_CARE,
    CAT1.WELLNESS,
    CAT1.HOME_AND_PET,
    CAT1.CULTURAL_SHIFTS,
    ...FOOD_ROOTS,
    CAT1.OCCASIONS,
];

export const HIDDEN_INDUSTRIES = [CAT1.MANIPULATION, CAT1.DOGS, CAT1.FLAVORS];

// Mirrored by HIDDEN_ROOTS in backend/constants/hidden_roots.py; change both.
export const HIDDEN_ROOTS = [
    ...HIDDEN_INDUSTRIES,
    CAT1.BODY_PARTS,
    CAT1.PRODUCT_SPECIFICS,
];

export const FLAG_STATUSES = {
    PENDING: 'PENDING',
    CLOSED: 'CLOSED',
};

export const SINGULAR_NAMES = {
    affinities: 'affinity',
    brands: 'brand',
    categories: 'category',
    countries: 'country',
    hashtags: 'hashtag',
    keywords: 'keyword',
    products: 'product',
};

export const {
    AUDIENCE,
    CLIENT_ID,
    DOMAIN,
    ALGOLIA_INDEX,
    ALGOLIA_SPOTLIGHTS_INDEX,
    MIXPANEL_TOKEN,
    BUGSNAG_FRONTEND_API_KEY,
} = window.spate_env;

export const GOOGLE_COUNTRIES = [
    GEO.GLOBAL,
    GEO.US,
    GEO.GB,
    GEO.FR,
    GEO.KR,
    GEO.JP,
];
export const TIKTOK_COUNTRIES = [
    GEO.GLOBAL,
    GEO.US,
    GEO.GB,
    GEO.FR,
    GEO.KR,
    GEO.JP,
];
export const INSTAGRAM_COUNTRIES = [
    GEO.GLOBAL,
    GEO.US,
    GEO.GB,
    GEO.FR,
    GEO.KR,
    GEO.JP,
];

const toObj = (arr) => Object.fromEntries(arr.map((k) => [k, 1]));

// Source of truth for coverage. The backend AI-assistant grid in
// backend/api/api2/services/ai/entity_data.py MUST mirror this — no test
// enforces parity, so change both together.
export const DATA_COVERAGE = {
    [GEO.GLOBAL]: {
        [DATA_SOURCES.POPULARITY]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.GOOGLE]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
        ]),
        [DATA_SOURCES.TIKTOK]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.INSTAGRAM]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
    },
    [GEO.US]: {
        [DATA_SOURCES.POPULARITY]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.GROCERY,
            CAT1.BEVERAGES,
            CAT1.CULINARY,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.FLAVORS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.GOOGLE]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.GROCERY,
            CAT1.BEVERAGES,
            CAT1.CULINARY,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.FLAVORS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.TIKTOK]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.GROCERY,
            CAT1.BEVERAGES,
            CAT1.CULINARY,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.FLAVORS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.INSTAGRAM]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.GROCERY,
            CAT1.BEVERAGES,
            CAT1.CULINARY,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.FLAVORS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
    },
    [GEO.GB]: {
        [DATA_SOURCES.POPULARITY]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.GOOGLE]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.TIKTOK]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
        [DATA_SOURCES.INSTAGRAM]: toObj([
            CAT1.BEAUTY,
            CAT1.PERSONAL_CARE,
            CAT1.WELLNESS,
            CAT1.INGREDIENTS,
            CAT1.HOME_AND_PET,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.BODY_PARTS,
            CAT1.PRODUCT_SPECIFICS,
        ]),
    },
    [GEO.FR]: {
        [DATA_SOURCES.POPULARITY]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.GOOGLE]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.TIKTOK]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.INSTAGRAM]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.CULTURAL_SHIFTS,
            CAT1.OCCASIONS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
    },
    [GEO.KR]: {
        [DATA_SOURCES.POPULARITY]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.GOOGLE]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.TIKTOK]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.INSTAGRAM]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
    },
    [GEO.JP]: {
        [DATA_SOURCES.POPULARITY]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.GOOGLE]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.TIKTOK]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
        [DATA_SOURCES.INSTAGRAM]: toObj([
            CAT1.BEAUTY,
            CAT1.INGREDIENTS,
            CAT1.PRODUCT_SPECIFICS,
            CAT1.BODY_PARTS,
        ]),
    },
};

export const isCovered = ({ geo, dataSource, cat1 }) =>
    !!DATA_COVERAGE?.[geo]?.[dataSource]?.[cat1];

/**
 * Whether any data source covers this cat1 in this geo.
 *
 * Navigation uses this rather than the per-source check: an industry the user
 * has access to should be reachable if *something* has data for it, and the
 * page they land on decides which sources to offer.
 */
export const isCoveredByAnySource = ({ geo, cat1 }) =>
    Object.values(DATA_COVERAGE?.[geo] || {}).some(
        (byCat1) => !!byCat1?.[cat1],
    );

// Coverage allowlist for the Instagram brand view at cat2 depth.
// - `'*'`  : all cat2s under this cat1 are supported
// - array  : only the listed cat2 names are supported (lower-cased compare)
// - missing key: no cat2 support for this cat1 in IG brand view
export const INSTAGRAM_BRAND_CAT2_COVERAGE = {
    [CAT1.BEAUTY]: '*',
    [CAT1.WELLNESS]: ['supplements & ingestibles'],
};

export const isInstagramBrandCat2Covered = ({ cat1, cat2 }) => {
    const allowed = INSTAGRAM_BRAND_CAT2_COVERAGE[cat1];
    if (allowed === '*') return true;
    if (!allowed) return false;
    return cat2 ? allowed.includes(cat2.toLowerCase()) : false;
};

export const hasInstagramBrandCat2Coverage = (cat1) => {
    const allowed = INSTAGRAM_BRAND_CAT2_COVERAGE[cat1];
    return allowed === '*' || (Array.isArray(allowed) && allowed.length > 0);
};

export const LANGUAGES = ['fr', 'ja', 'ko'];

export const DEFAULT_SEARCHABLE_ATTRIBUTES = ['name', 'hashtags'].concat(
    LANGUAGES.map((language) => `name_${language}`),
);
export const ADMIN_SEARCHABLE_ATTRIBUTES = DEFAULT_SEARCHABLE_ATTRIBUTES;

export const CONNECTIONS = ['clorox', 'elf', 'iff', 'loreal', 'ulta'];

export const CATEGORY_FILTERS = FOOD_ROOTS.reduce((acc, root) => {
    acc[root] = [CAT1.FLAVORS];
    return acc;
}, {});

export const UUID_NAMESPACE = '567f0e33-cda7-4a7e-8145-07225a27dc31';

export const AI_SERVICE_URL = (() => {
    if (window.spate_env && window.spate_env.AI_SERVICE_URL) {
        return window.spate_env.AI_SERVICE_URL;
    }

    const hostname = window.location.hostname;
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        return 'http://localhost:8080';
    }

    const errorMsg =
        `AI_SERVICE_URL not found in backend config for hostname: ${hostname}. ` +
        `Check that the config class (StagingConfig, ProductionConfig, etc.) defines AI_SERVICE_URL.`;
    console.error(errorMsg);
    throw new Error(errorMsg);
})();
